import { RecommendedProducts } from "../features";
import { END_POINTS } from "../helpers";
import {
  CommonBody,
  DashboardData,
  FeaturedProductsData,
  ProductSearchData,
  RecentProduct,
  globalSearch,
} from "../types/General";
import { Category } from "../types/General";
import { User } from "../types/User";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  statusCode: number;
  message: string;
};
type CategoriesData = {
  count: 9;
  pages: 1;
  category: Category[];
};

type RecentsProductsData = {
  count: number;
  maxPrice: number;

  pages: number;
  products: RecentProduct[];
};

type SearchHistoryResponse = {
  productSearch: ProductSearchData[];
};
type FeaturedProductsType = {
  count: number;
  maxPrice: number;
  pages: number;
  products: FeaturedProductsData[];
};

export const authApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query<
      CommonResponseType & { data: DashboardData },
      {}
    >({
      query: () => ({
        url: END_POINTS.dashboard,
        method: "GET",
      }),
    }),
    getRecentProducts: builder.mutation<
      CommonResponseType & { data: RecentsProductsData },
      {}
    >({
      query: () => ({
        url: END_POINTS.recentProducts,
        method: "POST",
      }),
    }),
    guestLogin: builder.mutation<
      CommonResponseType & { data: User },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.guestLogin,
        method: "POST",
        body,
      }),
    }),
    globalSearch: builder.query<
      CommonResponseType & {
        data: { ItemSearch: { productSearch: globalSearch[] } };
      },
      { search: string }
    >({
      query: ({ search }) => ({
        url: `${END_POINTS.globalSearch}?search=${search}`,
        method: "GET",
      }),
    }),
    getCategories: builder.query<
      CommonResponseType & { data: CategoriesData },
      {}
    >({
      query: ({}) => ({
        url: `${END_POINTS.category}`,
        method: "GET",
      }),
    }),
    postSaveSearchHistory: builder.mutation<
      CommonResponseType & { data: CategoriesData },
      CommonBody
    >({
      query: (body) => ({
        url: `${END_POINTS.saveSearchHistory}`,
        method: "POST",
        body,
      }),
    }),
    getSearchHistory: builder.query<
      CommonResponseType & { data: SearchHistoryResponse },
      {}
    >({
      query: () => ({
        url: `${END_POINTS.searchHistory}`,
        method: "GET",
      }),
    }),
    postClearSearch: builder.mutation<CommonResponseType & { data: any }, {}>({
      query: () => ({
        url: `${END_POINTS.clearSearch}`,
        method: "POST",
      }),
    }),
    getFeaturedProducts: builder.mutation<
      CommonResponseType & { data: FeaturedProductsType },
      {
        body: CommonBody;
        page: number;
        categoryId: string | undefined;
        sort: string;
        minPrice: number;
        maxPrice: number;
      }
    >({
      query: ({ body, page, categoryId, sort, minPrice, maxPrice }) => ({
        url: `${
          END_POINTS.featuredProducts
        }?page=${page}&size=${12}&categoryId=${categoryId}&sort=${sort}&minPrice=${minPrice}&maxPrice=${maxPrice}`,
        method: "POST",
        body,
      }),
    }),
    getRecommendedProducts: builder.mutation<
      CommonResponseType & { data: FeaturedProductsType },
      {
        body: CommonBody;
        page: number;
        categoryId: string | undefined;
        sort: string;
        minPrice: number;
        maxPrice: number;
      }
    >({
      query: ({ body, page, categoryId, sort, minPrice, maxPrice }) => ({
        url: `${
          END_POINTS.getProduct
        }?page=${page}&size=${12}&categoryId=${categoryId}&sort=${sort}&minPrice=${minPrice}&maxPrice=${maxPrice}`,
        method: "POST",
        body,
      }),
    }),
    getAllRecentProducts: builder.mutation<
      CommonResponseType & { data: RecentsProductsData },
      {
        body: CommonBody;
        page: number;
        categoryId: string | undefined;
        sort: string;
        minPrice: number;
        maxPrice: number;
      }
    >({
      query: ({ body, page, categoryId, sort, minPrice, maxPrice }) => ({
        url: `${
          END_POINTS.recentProducts
        }?page=${page}&size=${12}&categoryId=${categoryId}&sort=${sort}&minPrice=${minPrice}&maxPrice=${maxPrice}`,
        method: "POST",
        body,
      }),
    }),
    postSubscribeNewsLetter: builder.mutation<
      CommonResponseType & { data: any },
      CommonBody
    >({
      query: (body) => ({
        url: `${END_POINTS.subscribeNewsletter}`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetDashboardQuery,
  useGetRecentProductsMutation,
  useGuestLoginMutation,
  useLazyGlobalSearchQuery,
  useLazyGetCategoriesQuery,
  usePostSaveSearchHistoryMutation,
  useLazyGetSearchHistoryQuery,
  usePostClearSearchMutation,
  useGetFeaturedProductsMutation,
  useGetRecommendedProductsMutation,
  useGetAllRecentProductsMutation,
  usePostSubscribeNewsLetterMutation,
} = authApi;
